// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sdnz","content":"styles_content__U1qHG"};